import router from '@/router/'
import {DynamicRoutes} from '@/router/dynamic.js'//动态路由
import dynamicRouter from '@/router/dynamicRouter'

const permission = {
    state: {
        permissionList: null,
    },
    getters: {
  
    },
    mutations: {
        SET_PERMISSION(state, routes) {
            console.log(routes)
            state.permissionList = routes
        },
       
    },
    actions: {
        async FETCH_PERMISSION({ commit }) 
        {
            let MainContainer = DynamicRoutes.find(v => v.path === '');
            let children = MainContainer.children;
            if(localStorage.authorities)
            {
                if(localStorage.authorities.indexOf('ROLE_ADMIN')!=-1)
                {
                    children.push(...dynamicRouter[0],...dynamicRouter[1]);

                }else if(localStorage.authorities.indexOf('ROLE_AWARD_ADMIN')!=-1)
                {
                    children.push(...dynamicRouter[0]);
                }else if(localStorage.authorities.indexOf('ROLE_INPUT_UNIT_ADMIN')!=-1||localStorage.authorities.indexOf('ROLE_USER')!=-1||localStorage.authorities.indexOf('ROLE_INPUT_NATION')!=-1)
                {
                    children.push(...dynamicRouter[1]);
                }
            }

            /*  初始路由 */
            let initialRoutes = router.options.routes;
            
             /*  动态添加路由 */
            router.addRoutes(DynamicRoutes);
            commit('SET_PERMISSION', [...initialRoutes, ...DynamicRoutes]);
        }
        
    }
  }
  
  export default permission


// WEBPACK FOOTER //
// ./src/store/modules/permission.js